import { useState } from "react";

export type ThirdPartyData = {
    totalAppSize: number;
    thirdPartySize: number;
    thirdParties: {
        name: string;
        size: number;
        requests: number;
    }[];
};

export function use3rdPartyCalculation(): [ThirdPartyData | string | null, (data?: File) => void] {
    const [result, setResult] = useState<ThirdPartyData | string | null>(null);

    const callback = (data?: File) => {
        if (!data) {
            setResult(null);
            return;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const json = JSON.parse(event.target?.result as string);
                const data = json.audits?.["third-party-summary"]?.details?.items || [];
                if (data.length === 0) {
                    setResult("No third-party data found in the provided Lighthouse JSON.");
                    return;
                }
                const results = {
                    totalAppSize: json.audits?.["total-byte-weight"]?.numericValue || 0,
                    thirdPartySize: data.reduce((sum: number, item: any) => sum + (item.transferSize || 0), 0),
                    thirdParties: data.map((item: any) => ({
                        name: item.entity || "Unknown",
                        size: item.transferSize || 0,
                        requests: item.subItems?.items?.length || 1,
                    })).sort((a: any, b: any) => b.size - a.size),
                };
                setResult(results);
            } catch (error) {
                console.error("Error parsing JSON:", error);
                setResult("Error parsing JSON file.");
            }
        };
        reader.onerror = (error) => {
            console.error("Error reading file:", error);
            setResult("Error reading file.");
        };
        reader.readAsText(data);
    }

    return [result, callback];
}

export default use3rdPartyCalculation;